import React from 'react'
import { useTranslation } from 'react-i18next'

import { useMsal } from '@azure/msal-react'
import { Button } from 'primereact/button'

import Config from '../../../utils/config'

function SignInButton(): React.ReactElement {
  const { t } = useTranslation()
  const { instance } = useMsal()

  const handleLogin = (): void => {
    instance.loginRedirect({
      scopes: Config.auth.scopes,
      redirectUri: window.location.href,
    })
  }

  return (
    <Button className="p-button-text p-button-plain" onClick={() => handleLogin()}>
      <i className="pi pi-sign-in mr-2"></i>
      <span className="">{t('common.account.signIn')}</span>
    </Button>
  )
}

export default SignInButton
